import { DEFAULT_NURSERY_BRAND_COLOR } from "src/shared/config/src";
import { RootState } from "src/shared/types/src";

export const getIsLoggedIn = (state: RootState) => state?.login?.isLoggedIn || false;

export const getLoginData = (state: RootState) => state?.persistLogin?.loginData;

export const getTnCAcceptance = (state: RootState) => state?.persistLogin?.loginData?.termsAccepted || false;

export const getShowAppTour = (state: RootState) => state?.persistLogin?.loginData?.showAppTour || false;

export const getLoggedInUserEmail = (state: RootState) => state?.persistLogin?.loginData?.username || "";

export const getIsAuthLoading = (state: RootState) => state?.login?.isAuthLoading || false;

export const getIsUpdateCurrentChildLoading = (state: RootState) => state?.persistLogin?.isUpdateCurrentChildLoading || false;

export const getCurrentChild = (state: RootState) => state?.persistLogin?.currentChild;

export const getCurrentNursery = (state: RootState) => state?.persistLogin?.currentNursery;

export const getAllChildren = (state: RootState) => state?.persistLogin?.loginData?.children || [];

export const getChildrenGroupedByNursery = (state: RootState) => state?.persistLogin?.groupedByNursery || [];

export const getAllActiveChildren = (state: RootState) => state?.persistLogin?.loginData?.children.filter((child) => child.active) || [];

export const getNurseryBrandColor = (state: RootState) => (
    state?.persistLogin?.currentChild?.nursery?.brandingColor ||
    state?.persistLogin?.currentNursery?.brandingColor ||
    DEFAULT_NURSERY_BRAND_COLOR
)